import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, Mail, MapPin, Phone, Instagram } from 'lucide-react';
import { useFooterGlow } from '../context/FooterGlowContext';
import './Footer.css';

const Footer = () => {
  const { shouldGlow } = useFooterGlow();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section">
            <div className="footer-brand">
              <Camera className="logo-icon" />
              <span className="brand-text">Vellichor Visions</span>
            </div>
            <p className="footer-description">
              Capturing moments that create nostalgia. Professional photography 
              services in Scottsdale and Phoenix, Arizona.
            </p>
            <div className="social-links">
              <a href="https://www.instagram.com/vellichorvisionsllc" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Services Section */}
          <div className="footer-section">
            <h3>Services</h3>
            <ul className="footer-links">
              <li><Link to="/portraits">Portrait Photography</Link></li>
              <li><Link to="/headshots">Company Headshots</Link></li>
              <li><Link to="/real-estate">Real Estate Photography</Link></li>
              {/* <li><Link to="/blog">Photography Blog</Link></li> */} {/* Blog page deactivated */}
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/booking">Book a Session</Link></li>
              {/* <li><Link to="/blog">Blog</Link></li> */} {/* Blog page deactivated */}
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className={`footer-section contact-section ${shouldGlow ? 'glow' : ''}`}>
            <h3>Contact Us</h3>
            <div className="contact-info">
              <div className="contact-item">
                <Mail size={16} />
                <a href="mailto:vellichorvisions@gmail.com">vellichorvisions@gmail.com</a>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <a href="tel:+14803343330">(480) 334-3330</a>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Scottsdale & Phoenix, AZ</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; 2024 Vellichor Visions Photography LLC. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 